import React from 'react'

import { Form, Col } from '_zari/core'

const CodigoSerieFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='SERIE' htmlFor='input-codigoSerie' md={4} />
      <Col md={8}>
        <Form.InputText
          id='input-codigoSerie'
          value={value}
          onChange={onChange}
          placeholder='Ingrear serie ...'
        />
      </Col>
    </Form.Group>
  )
}

export default CodigoSerieFormGroup
